<template>
  <EntrepriseContentWrapper :entreprise-id="$route.params.id">
    <router-view />
  </EntrepriseContentWrapper>
</template>

<script>
import EntrepriseContentWrapper from "./EntrepriseContentWrapper.vue";

export default {
  name: "EntreprisePageWrapper",
  components: {
    EntrepriseContentWrapper,
  },
};
</script>
